import React from 'react';
import VisaIcon from '../icons/VisaIcon';
import AmexIcon from '../icons/AmexIcon';
import MasterCardIcon from '../icons/MasterCardIcon';
import DinersLogo from '../icons/DinersLogo';
import JcbLogo from '../icons/JcbLogo';
import UnionPayLogo from '../icons/UnionPayLogo';
import BccCardLogo from '../icons/BccCardLogo';
import DinaCardLogo from '../icons/DinaCardLogo';
import DiscoverLogo from '../icons/DiscoverLogo';

const CardBrandIcons = ({ brand }) => {
  switch (brand) {
    case 'visa':
      return <VisaIcon />;
    case 'amex':
      return <AmexIcon />;
    case 'mastercard':
      return <MasterCardIcon />;
    case 'discover':
      return (
        <>
          <div className='mr-1'>
            <DiscoverLogo />
          </div>

          <div className='mr-1'>
            <DinaCardLogo />
          </div>
          <div className='mr-1'>
            <BccCardLogo />
          </div>
        </>
      );
    case 'diners':
      return <DinersLogo />;
    case 'jcb':
      return <JcbLogo />;
    case 'unionpay':
      return <UnionPayLogo />;
    default:
      return null;
  }
};

export default CardBrandIcons;
